<script setup>
import { onMounted, ref } from 'vue'
import { auth_user, auth_sso } from '@/services/auth';
import { useRouter } from 'vue-router';
import { swalError } from '@/helper';

const router = useRouter()
const active = ref(true)
const loading = ref(false)
const user = ref({})
async function login (){
  const queryString = window.location.search;
  console.log(queryString);
  const urlParams = new URLSearchParams(queryString);
  
  loading.value = true
  let response = ''
  let needRedirect = false
  if (urlParams.has('sso') && urlParams.has('sig')){
    needRedirect = true
    const sig = urlParams.get('sig')
    const sso = urlParams.get('sso')
    response = await auth_user(user.value, {sig, sso})
  }else{
    response = await auth_user(user.value)
  }
  loading.value = false
  if (response.error){
    swalError(response.result?.error || response.error || 'Login failed', true)
  }else{
    // Store user data
    const userData = response.result?.data || response.data;
    if (userData) {
      localStorage.setItem('user_data', JSON.stringify(userData))
      if (needRedirect && response.result?.sso){
        let forum_redirect = 'http://localhost:3000/session/sso_login' + '?'
        let params_redirect = `sso=${response.result.sso.sso}&sig=${response.result.sso.sig}`
        window.location.replace(forum_redirect+params_redirect)
      }else{
        router.push({name: 'dashboard'})
      }
    }else{
      swalError('Invalid response from server')
    }
  }
}

function show (){
  active.value = !active.value
}

onMounted(async ()=>{
  const queryString = window.location.search;
  console.log(queryString);
  const urlParams = new URLSearchParams(queryString);
  if(localStorage.getItem('uid') !== null){
    if (urlParams.has('sso') && urlParams.has('sig')){
      loading.value = true
      const sig = urlParams.get('sig')
      const sso = urlParams.get('sso')
      let response = await auth_sso({sig, sso})
      let params_redirect = `sso=${response.result.sso.sso}&sig=${response.result.sso.sig}`
      window.location.replace(response.result.sso.redirect_url+'?'+params_redirect)
    }else{
      router.push({name: 'dashboard'})
    }
  }
})
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xl-7 b-center bg-size p-0" :style="{ backgroundImage: 'url('+ require('../assets/images/login/login.png') +')' }" style="background-color: #f8f9ff; background-size: cover; background-position: center center; display: block;">
      </div>
      <div class="col-xl-5 p-0">
        <div class="login-card">
          <div>
            <div>
              <a class="logo">
                <img class="img-fluid" src="../assets/images/logo/logo.png" width="200" alt="looginpage" />
              </a>
            </div>
            <div class="login-main ">
              <form class="theme-form" @submit.prevent="login()">
                <h4>Sign in to account</h4>
                <p>Enter your email & password to login</p>
                <div class="form-group">
                  <label class="col-form-label">Email Address</label>
                  <input :disabled="loading" class="form-control" type="email" required="" placeholder="abc@mail.com" v-model="user.email" autofill/>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Password</label>
                  <div class="form-input position-relative">
                    <input :disabled="loading" class="form-control" :type="active?'password':'text'" name="login[password]" required="" placeholder="*********"  v-model="user.password" autofill/>
                    <div class="show-hide"><span :class="active?'show':'hide'" @click.prevent="show"> </span></div>
                  </div>
                </div>
                <div class="form-group mb-0">
                  <div class="checkbox p-0">
                    <input id="checkbox1" type="checkbox" />
                    <label class="text-muted" for="checkbox1">Remember password</label>
                  </div>
                  <button type="submit" class="btn btn-primary btn-block">
                    <span v-if="loading">
                      <div class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </span>
                    <span v-else>
                      Sign in
                    </span>
                  </button>
                </div>
                <!-- <h6 class="text-muted mt-4 or">Or Sign in with</h6> -->
                <!-- <div class="social mt-4">
                  <div class="btn-showcase">
                    <a class="btn btn-light" href="https://www.facebook.com/" target="_blank">
                      <img class="bg-img-cover bg-center" src="../assets/images/facebook.png" width="18" alt="google" />
                      Facebook
                    </a>
                    <a class="btn btn-light" href="https://www.google.com/" target="_blank">
                      <img class="bg-img-cover bg-center" src="../assets/images/google.png" width="15" alt="google" />
                      Google
                    </a>
                  </div>
                </div> -->
                <p class="mt-4 mb-0">
                  Don't have account?
                  <router-link class="ms-2" tag="a" to="/register">
                    Create Account
                  </router-link>
                </p>
                <div class="mt-3 text-center">
                  <router-link to="/privacy-policy" class="text-muted small">
                    Privacy Policy
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>